export const FORM_FIELDS_NAMES = {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    AGE: 'age',
    CONTACT_NUMBER: 'contactNumber',
    RELATION: "relationWithPatient",
    EMAIL: "email",
    ADDRESS: 'address'
}
